import { render, staticRenderFns } from "./page-3.vue?vue&type=template&id=dfd4525c&scoped=true&"
import script from "./page-3.vue?vue&type=script&lang=js&"
export * from "./page-3.vue?vue&type=script&lang=js&"
import style0 from "./page-3.vue?vue&type=style&index=0&id=dfd4525c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd4525c",
  null
  
)

export default component.exports